export const renewalPlan = 0;
export const currentPlan = 1;
export const newPlan = 2;